import styled from 'styled-components';
import { H2 } from '@workramp/ui';

export const SettingsHeader = styled.div`
  display: flex;
`;

export const HeadingWrapper = styled(H2)`
  margin-right: ${({ theme }) => theme.spacing(2)}px;
`;
